import * as React from "react";

import { Card } from "#app/components/ui/card-legacy";
import { cn } from "#app/utils/misc.tsx";

type BrandCardProps = React.ComponentPropsWithoutRef<typeof Card>;

const BrandCard = React.forwardRef<HTMLDivElement, BrandCardProps>(
  ({ className, ...props }, ref) => (
    <Card
      ref={ref}
      className={cn(
        "rounded-xl border-[#E3E8F5] bg-white shadow-sm transition-all dark:bg-zinc-900",
        "hover:-translate-y-0.5 hover:shadow-md",
        "hover:bg-[linear-gradient(101.63deg,#EFF3FC_20.48%,#F8F9FC_37.01%,#FFFFFF_52.4%)] dark:hover:bg-none dark:hover:bg-zinc-800/60",
        "focus-within:ring-2 focus-within:ring-[#535EA4]/15 focus-within:ring-offset-2",
        className,
      )}
      {...props}
    />
  ),
);
BrandCard.displayName = "BrandCard";

export { BrandCard };
